import React from 'react';

import '../css/Header.css'

const Header = () => {
  return (
    <div className="header">
      <h1 className="header-title">String Reverser</h1>
    </div>
  )
}

export default Header;